// Ebeveyn uygulamasında ekranı düzenleme, Türkçe (bkz. boardConfigApp.nl.ts).
export const appBoardConfigTr = {
    open: 'Ekranı düzenle',
    title: 'Ekranı düzenle',
    intro: 'Widget’ları ızgarada taşı; daralt, genişlet, kısalt veya uzat: ne kadar büyükse o kadar çok gösterir. Bir panoda en fazla 12 sayfa olur; panoda yana kaydırarak sonrakine geçersin.',
    standard: 'Bu pano şu an standart düzeni gösteriyor. Kendi düzenin için bir şey değiştir.',
    onBoard: 'Panoda',
    available: 'Ekle',
    nothingToAdd: 'Modüllerinizin tüm widget’ları zaten ekli.',
    empty: 'Bu sayfada henüz bir şey yok. Aşağıdan ekle.',
    size: 'Boyut',
    style: 'Görünüm',
    moveUp: '{name} yukarı',
    moveDown: '{name} aşağı',
    remove: '{name} kaldır',
    pageEarlier: '{name} öne al',
    pageLater: '{name} arkaya al',
    pageRemove: '{name} kaldır',
    onPage: '{name} üzerinde',
    weekSketch: 'Haftanın takvimi',
    phoneHint: 'Taşıma ve boyutlandırma tablet veya bilgisayarda yapılır. Burada her sayfada ne olacağını seçersin.',
    add: '{name} ekle',
    reset: 'Standart düzen',
    save: 'Kaydet',
    saved: 'Kaydedildi. Pano bir dakika içinde kendini ayarlar.',
    resetDone: 'Standart düzen hazır. Panoya koymak için kaydet.',
    failed: 'Kaydedilemedi. Birazdan tekrar dene.',
    conflict: 'Bu pano bu arada değişti, belki panonun kendisinde. En yeni düzen şimdi görünüyor.',
    preview: 'Önizleme',
    previewNote: 'Örnek verilerle; pano sizin verilerinizi kullanır.',
    screen: 'Ekran',
    screens: { large: 'iPad', wide: 'Geniş tablet', compact: 'Küçük tablet' },
    gestureTitle: 'Panonun kendisinde düzenle',
    gestureBody: 'Panodaki saate hızlıca üç kez dokun ve ebeveyn PIN’ini gir. Bir dakika dokunulmazsa kendiliğinden kapanır.',
    pinTitle: 'Kişisel ebeveyn PIN kodum',
    pinBody: 'Kendi PIN kodunu kullan. Her ebeveynin kişisel PIN kodu vardır.',
    pinLabel: 'Yeni ebeveyn PIN',
    pinSave: 'PIN’i kaydet',
    pinSaved: 'Ebeveyn PIN’in kaydedildi.',
    pinInvalid: '4 ile 6 rakam seç.',
    pinTaken: 'Bu PIN kodunu başka bir ebeveyn zaten kullanıyor. Başka bir tane seç.',
    back: 'Tabletlere dön',
    names: {
        prayer: 'Namaz vakitleri',
        weather: 'Hava durumu',
        tasks: 'Görevler',
        rides: 'Bırakma ve alma',
        meals: 'Yemek',
        upcoming: 'Yakında',
        messages: 'Mesajlar',
        memorize: 'Sure ezberi',
        dinner: 'Kim yemekte',
        bookings: 'Rezervasyon',
        precip: 'Yağış',
        week: 'Hafta (en düşük ve en yüksek)',
        quran: 'Kuran dinle',
        todos: 'Yapılacaklar',
        notes: 'Notlar',
        // 0068: Gezond op gewicht.
        kompas: 'Sağlıklı alışkanlıklar (Sağlıklı kilo)',
        // 0076: schoolplanner (nooit een cijfer op het bord).
        school: 'Okul (ödev ve sınavlar)',
        // 0062: module Jodendom.
        shabbat: 'Şabat ve takvim',
        // 0061: Kerk & kalender.
        seasons: 'Kilise ve takvim',
        // 0063: module Hindoeïsme.
        almanac: 'Panchang ve bayramlar',
        // UX-ronde bord: Boodschappen (module Eten) en Beloningen.
        groceries: 'Alışveriş listesi',
        rewards: 'Ödüller',
        // 0075: Huisronde (module Eten).
        house_round: 'Ev turu',
        // Widgets compleet: Wensen, Foto (Fotolijst), Timer, Schoonmaak en Beurtrooster.
        wishes: 'Dilekler',
        photo: 'Fotoğraf (Fotoğraf çerçevesi)',
        timer: 'Zamanlayıcı',
        cleaning: 'Temizlik',
        rotation: 'Sıra çizelgesi',
        // Widgets privé (0077): de gewone nieuwe widgets en de privé-widgets.
        clock: 'Saat',
        travel: 'Çıkış',
        stock: 'Stok',
        cookbook: 'Yemek defteri',
        reminders: 'Hatırlatmalar',
        checkin: 'Günlük bildirim',
        fasting: 'Oruç',
        growth: 'Büyüme',
        money: 'Para işleri',
        expenses: 'Masraf paylaşımı',
        my_todos: 'Özel yapılacaklar',
        circle: 'Aile çevresi',
    },
    sizes: { S: 'Küçük', M: 'Orta', L: 'Büyük', XL: 'Çok büyük' },
    sizeHints: {
        S: 'En önemlisi bir bakışta',
        M: 'Bugün',
        L: 'Bugün ve yarın, daha ayrıntılı',
        XL: 'Her şey, geniş ekranda',
    },
    /** Fijnslijpen ouderapp: Brengen en halen, de ophaaltijd als schakelaar (stijl list of no_pickup). */
    ridesPickup: 'Alma saatini göster',
    ridesPickupHint: 'Örneğin "Babam 16:50’de alıyor". Kapalı: yalnızca kimin aldığı.',
    styles: {
        // Widget Foto.
        slideshow: 'Her dakika değişir',
        daily: 'Günün fotoğrafı',
        no_pickup: 'Alma saati olmadan',
        list: 'Liste',
        ring: 'Saat',
        compact: 'Sade',
        illustrated: 'Resimli',
        today: 'Yalnızca bugün',
        bars: 'Çubuklar',
    },
    /** Koran luisteren: "Over de opnames" bij de widget. */
    quran: {
        aboutTitle: 'Kayıtlar hakkında',
        aboutBody: 'Okuyan: {name}. Kaynak: {source}.',
        familyOnly: 'Bilinen bir lisans yok: bu kayıtlar yalnızca sizin aileniz için.',
        none: 'Aileniz için henüz kayıt yok.',
    },
    /** Voorbeeldgezin in het voorbeeld van "Scherm inrichten" (kiosk-ui widgets/sample.ts). */
    samples: {
        // Widgets compleet: wensen, klussen en een bijschrift van het voorbeeldgezin.
        wishLego: 'Lego uzay gemisi',
        wishBook: 'Hayvan kitabı',
        wishSkates: 'Paten',
        choreBathroom: 'Banyo',
        choreVacuum: 'Süpürmek',
        choreBins: 'Çöpü çıkarmak',
        photoCaption: 'Deniz kenarında yaz',
        school: 'Okul',
        swimming: 'Yüzme dersi',
        judo: 'Judo',
        brushTeeth: 'Diş fırçalamak',
        packBag: 'Çanta hazırlamak',
        makeBed: 'Yatağı toplamak',
        setTable: 'Sofrayı kurmak',
        groceries: 'Alışveriş',
        birthday: 'Noor 8 yaşında',
        autumnBreak: 'Sonbahar tatili',
        pasta: 'Pesto soslu makarna',
        soup: 'Çorba',
        curry: 'Köri',
        pancakes: 'Krep',
        pizza: 'Pizza',
        stew: 'Türlü',
        inHours: '{n} sa',
        paintCupboard: 'Ayakkabı dolabını boya',
        fixBike: 'Bisiklet lastiğini yama',
        clearGutter: 'Olukları temizle',
        noteMilk: 'Süt bitti',
        noteSwim: 'Yüzme çantasını unutma',
        // UX-ronde bord: voorbeeld voor de widgets Boodschappen en Beloningen.
        milk: 'Süt',
        bread: 'Ekmek',
        apples: 'Elma',
        cheese: 'Peynir',
        cinema: 'Sinema',
    },
};
//# sourceMappingURL=boardConfigApp.tr.js.map